//TODO : 
// date format
// refresh

import React from 'react';
import { CardMedium } from '../../widgets/Cards';
import Modal from '../../widgets/Modal';
import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
import { fetchHistories, fetchHistory, editHistory, newHistory, deleteHistory} from '../../../actions';
import { Form, Field} from 'react-final-form';

class History extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            newForm : true,
            record : null,
        };
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchHistories(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchHistories(this.props.patient._id)
        }
        
    }

    renderHistoryList() {
///// Here
        return this.props.histories.map(hx =>  {

            const rowButton = () => {
                var permit = this.props.selectedPermission.permission[0].chronicdisease;
                if (permit === "View only") {
                    return null;
                } else { 
                    return (
                        <>
                        <button onClick={() => this.setState({showModal: true, newForm: false, record: hx._id})} className='tableEdit'><i className="far fa-edit"></i></button>
                        <button onClick={() => this.setState({showDelete: true, record: hx._id})} className='tableDelete'><i className="fas fa-trash"></i></button>
                        </>
                    )
                }  
            }
            
            return (
                    <tr key={hx._id}>
                        <td>{hx.day}/{hx.month}/{hx.year}</td>
                        <td>{hx.condition}</td>
                        <td>{hx.status}</td>
                        <td>{hx.acute}</td>
                        <td>{hx.provider}</td>
                        <td>
                            {rowButton()}
                        </td>
                    </tr>
            )
        })
    }

    buttons() {
        var permit = this.props.selectedPermission.permission[0].chronicdisease;
        if (permit === "View only") {
            return null
        } else { 
            return  <button onClick={() => this.setState({showModal: true, newForm: true, record: null})} className='btnew'>Add</button>
        }  
    }

    render() {
        return (
        
                <CardMedium title='History' buttons={this.buttons()}>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Condition</th>
                                <th>Status</th>
                                <th>Acute/Chronic</th>
                                <th>Provider</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody> 
                            {this.renderHistoryList()}
                        </tbody> 
                    </table>
                    
                {this.renderModalBox()}
                {this.renderDeleteBox()}
                </CardMedium>
        )
    }

    renderDeleteBox() {

        const handleDelete = () => {
            this.props.deleteHistory(this.state.record);
            this.setState({showDelete:false, record:null})
        }

        const deleteButtons = () => {
            return (
            <div>
                <button onClick={() => this.setState({showDelete: false})} className='btdel'>Cancel</button>
                <button onClick={handleDelete} className='btsave'>Ok</button>
            </div>
            )
        }

        return (
            <Confirm
                height='100px'
                width='300px'
                open={this.state.showDelete} 
                data={this.state.record}
                content="Delete this history ?"
                title='Delete History'
                actions = {deleteButtons()}
                onDismiss={() => this.setState({showDelete : false, record:null})}
            />
        )

    }

    
    renderModalBox() {
        const record = this.state.record;
        if (record !== null) {
           this.props.fetchHistory(record);
        }

        //content of the Modal Box

        const historyForm = () => {
            const required = value =>(value ? undefined : 'Required');
         
            var content;
            if (this.state.newForm === false ) {
                content = this.props.selectedHistory;
            } else {
                content = null;
            }
            const currentHistory = content;

            const handleSubmit = (formValues) => {
            
                const form = formValues;
                form['patientId'] = this.props.patient._id;
                form['userId'] = this.props.userId;  

                const historyId = form._id;
                if (historyId === undefined) {
                    this.props.newHistory(form);
                } else {
                    this.props.editHistory(form, historyId);
                }
                this.setState({showModal :false, newForm : true,record : null,});
           }

            return (
                <Form 
                    onSubmit = {handleSubmit} 
                    initialValues = {currentHistory}
                    render = {({ handleSubmit, pristine, form, values, submitting }) => {
                    return   (
                            <form onSubmit={handleSubmit}>
                                    <Field name='day'  validate={required} placeholder=''>
                                        {({input, meta}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Day</label>
                                                    <input {...input}  />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                            )}
                                    </Field>
                                    <Field name='month'  validate={required} placeholder=''>
                                        {({input, meta}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Month</label>
                                                    <input {...input}  />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                            )}
                                    </Field>
                                    <Field name='year'  validate={required} placeholder=''>
                                        {({input, meta}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Month</label>
                                                    <input {...input}  />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                            )}
                                    </Field>
                                    <Field name="condition" component='input' validate={required} placeholder='Enter vaccine Name'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Condition</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="status" component='input'>
                                        {({ input}) => (
                                            <div>
                                                <label>Status</label>
                                                <select {...input}>
                                                    <option value="Active">Active</option>
                                                    <option value="Inactive">Inactive</option>
                                                </select>
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="acute" component='input'>
                                        {({ input}) => (
                                            <div>
                                                <label>Acute</label>
                                                <select {...input}>
                                                    <option value="Acute">Acute</option>
                                                    <option value="Chronic">Chronic</option>
                                                    <option value="Temporary">Temporary</option>
                                                </select>
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="provider" component='input' validate={required} placeholder='Enter provider name'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Provider</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                    <div className='modalButton'>
                                        <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                        <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                        <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                                    </div>
                            </form>
                        )
                    }}
                />
            )
        }   
        //  <pre>{JSON.stringify(values, 0, 2)}</pre>

// main render
        return (
            <Modal 
                height='400px'
                width='240px'
                open={this.state.showModal} 
                title='Edit History'
                data={this.state.record}
                content={historyForm()}
                onDismiss={() => this.setState({showModal: false, record: null})}
            />
        )
    }

}


const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        histories : Object.values(state.histories),
        userId : state.auth.userId,
        selectedHistory : state.selectedHistory,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {fetchHistories, fetchHistory, editHistory, newHistory, deleteHistory})(History);





